var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { MedicationType, MedicinalProductSearchBy } from '../Contracts/MedicationModels';
import { MedicationsBrowserDialog } from '../MedicationBrowser/MedicationsBrowserDialog';
import { ReprescribeFreeTextMedicationDialog } from './ReprescribeFreeTextMedicationDialog';
var DialogType;
(function (DialogType) {
    DialogType[DialogType["TypeSelect"] = 0] = "TypeSelect";
    DialogType[DialogType["MedicationSelect"] = 1] = "MedicationSelect";
})(DialogType || (DialogType = {}));
export function isFreeTextMedication(chosenMedication) {
    if (chosenMedication.pbsDetail == undefined &&
        chosenMedication.poisonSchedule == undefined)
        return true;
    return false;
}
export var ReprescribeFreeTextMedication = function (props) {
    var _a = __read(useState(DialogType.TypeSelect), 2), step = _a[0], setStep = _a[1];
    var _b = __read(useState(null), 2), medicationType = _b[0], setMedicationType = _b[1];
    var submitMedicationType = function (medicationType) {
        setMedicationType(medicationType);
        setStep(DialogType.MedicationSelect);
    };
    var selectMedicationFromBrowser = function (medication) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (medicationType)
                props.onSelectionMedication({
                    patientMedication: props.patientMedication,
                    type: medicationType,
                    medication: medication
                });
            return [2 /*return*/];
        });
    }); };
    var selectFreeTextMedicationFromBrowser = function (name) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (medicationType)
                props.onSelectionMedication({
                    patientMedication: props.patientMedication,
                    type: medicationType,
                    medication: {
                        code: 'FreeTextMedication',
                        name: name
                    }
                });
            return [2 /*return*/];
        });
    }); };
    return (React.createElement(React.Fragment, null,
        step === DialogType.TypeSelect && (React.createElement(ReprescribeFreeTextMedicationDialog, { onSubmit: submitMedicationType, onClose: props.onClose })),
        step === DialogType.MedicationSelect && (React.createElement(MedicationsBrowserDialog, { defaultFilter: {
                productName: props.freeText,
                medicinalProductSearchBy: MedicinalProductSearchBy.All,
                limit: 50
            }, isComplementaryTherapy: medicationType === MedicationType.ComplementaryTherapyOrder, freeTextMedicationName: props.freeText, onCancel: props.onClose, onSelectMedication: selectMedicationFromBrowser, onSelectFreeTextMedication: selectFreeTextMedicationFromBrowser }))));
};
